import { fmt } from "@/lib/api";

const Row = ({ l, v, sub, testid }) => (
  <div className="flex items-baseline justify-between py-3 border-b border-kl-line last:border-0" data-testid={testid}>
    <span className="text-sm text-kl-muted">{l}</span>
    <span className="text-right"><span className="font-mono text-base">{v}</span>{sub && <span className="block text-[11px] text-kl-muted">{sub}</span>}</span>
  </div>
);

export default function SizingCard({ sizing }) {
  const { pv, inverter, battery, economics: e, confidence, inputs } = sizing;
  const cur = e.currency;
  const sec = e.secondary;
  const region = sizing.region;
  return (
    <div className="kl-panel-dark p-6 relative overflow-hidden" data-testid="sizing-card">
      <div className="absolute top-0 left-0 right-0 h-px overflow-hidden"><div className="h-px w-1/3 bg-kl-green animate-scan" /></div>
      <div className="flex items-start justify-between">
        <div><p className="kl-label-dark">Sizing engine · v2 {region?.name && <span className="text-kl-green" data-testid="sizing-region">· {region.name} inventory · {cur}</span>}</p><h3 className="font-display font-light text-2xl mt-1">Recommended system</h3></div>
        <span className={`shrink-0 whitespace-nowrap font-mono text-[9px] uppercase tracking-wider px-1.5 py-0.5 border ${confidence === "high" ? "border-kl-green text-kl-green" : confidence === "medium" ? "border-yellow-400 text-yellow-400" : "border-kl-inactive text-kl-inactive"}`} data-testid="sizing-confidence">{confidence} confidence</span>
      </div>

      <div className="grid grid-cols-3 gap-px bg-kl-line border border-kl-line mt-6">
        {[["Panels", pv.count, `${pv.panel?.rating ?? 0} W each`, "panels"], ["Inverter", `${inverter.recommended?.rating ?? inverter.required_kw}`, `kW × ${inverter.count}`, "inverter"], ["Battery", `${battery.total_kwh}`, `kWh × ${battery.count}`, "battery"]].map(([l, v, s, id]) => (
          <div key={l} className="bg-kl-black p-4" data-testid={`sizing-${id}`}>
            <div className="kl-label-dark">{l}</div>
            <div className="font-mono text-3xl text-kl-green mt-1">{v}</div>
            <div className="text-[11px] text-kl-muted">{s}</div>
          </div>
        ))}
      </div>

      <div className="mt-4">
        <Row l="Array size" v={`${pv.array_kw} kWp`} sub={`${pv.required_kw} kW required · ${pv.roof_area_m2} m² roof`} testid="sizing-array" />
        <Row l="Panel" v={pv.panel?.model || "—"} sub={pv.panel ? `${pv.panel.efficiency}% · ${fmt.money(pv.panel.price, cur)}` : "add a panel in catalog"} />
        <Row l="Inverter" v={inverter.recommended?.model || "—"} sub={`${inverter.required_kw} kW required (peak × ${inputs.peak_kw ? (inverter.required_kw / inputs.peak_kw).toFixed(2) : "—"})`} />
        <Row l="Battery" v={battery.recommended?.model || "—"} sub={`${battery.required_kwh} kWh night reserve`} />
        <Row l="System cost" v={fmt.money(e.system_cost, cur)} sub={sec ? `≈ ${fmt.money(sec.system_cost, sec.currency)} · 1 ${cur} = ${sec.rate.toFixed(4)} ${sec.currency}` : ""} testid="sizing-cost" />
        <Row l="Annual generation" v={`${e.annual_generation_kwh.toLocaleString()} kWh`} sub={`${inputs.sun_hours} sun-h · ${Math.round(inputs.system_efficiency * 100)}% eff.`} />
        <Row l="Annual savings" v={fmt.money(e.annual_savings, cur)} sub={`${sec ? `≈ ${fmt.money(sec.annual_savings, sec.currency)} · ` : ""}${fmt.money(inputs.tariff, cur, 2)}/kWh${e.payback_years ? ` · payback ${e.payback_years} yrs · ${e.co2_offset_kg.toLocaleString()} kg CO₂/yr` : ""}`} testid="sizing-savings" />
      </div>
    </div>
  );
}
